<template>
  <div class="productList">
    <Header />
    <div class="container main">
      <Product :products="products.data"
               :brands="products.brands"
               @getProductList="getProductList" />
      <div class="pages">
        <el-pagination background
                       layout="prev, pager, next"
                       :total="products.total"
                       @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <div class="zhimabg"
         @click="onZhima"
         v-if="endtime<20190820105406498"></div>
    <Footer />
  </div>
</template>

<script>
import { NowTimeCode } from "@/utils/index";

import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
import Product from "@/components/PC/List/Product";

export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      page: 1,
      size: 12,
      keyword: "",
      endtime: NowTimeCode()

    };
  },
  components: {
    Header,
    Footer,
    Product
  },
  mounted: function () {
    window.scroll(0, 0);
    this.fetchProductList();
  },
  computed: {
    products () {
      return this.$store.state.product.products;
    },
    catId () {
      return this.$store.state.product.catId;
    },
    brandId () {
      return this.$store.state.product.brandId;
    }
  },
  methods: {
    fetchProductList () {
      let params = {
        page: this.page,
        keyword: this.keyword,
        catId: this.catId,
        brandId: this.brandId,
        size: this.size
      };
      this.$store.dispatch("product/fetchProductList", { params }).then(() => {
      });
    },
    handleCurrentChange (value) {
      this.page = value
      this.fetchProductList()
    },
    getProductList () {
      this.fetchProductList();
    },
    onZhima () {
      let url = "https://cuxiao.m.suning.com/scms/wapdn03669.html?utm_source=pl-00005&utm_medium=hp-shs-bn-w1-m"
      window.location.href = url;
    },
  },
  created () {
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }
  }
};
</script>
<style>
.productList {
  background: #f3f3f3;
}
.productList .pages {
  margin: 30px 0 0 0;
}
.zhimabg {
  width: 152px;
  height: 85px;
  background: url(https://image.suhuishou.com/attached/image/20190813/20190813115001_17373.jpg)
    no-repeat;
  background-size: 100%;
  position: fixed;
  left: 20px;
  bottom: 240px;
}
</style>
